import { Box, Flex, Anchor } from "@mantine/core";
import { IconBuilding, IconWorld, IconId } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type SignupFlowLayoutProps = {
  children: ReactNode;
};

export function SignupFlowLayout({ children }: SignupFlowLayoutProps) {
  return (
    <Box style={{ minHeight: "100vh", display: "flex" }}>
      <Box
        style={{
          flex: "0 0 40%",
          position: "relative",
          overflow: "hidden",
        }}
        visibleFrom="md"
      >
        <img
          src="/LoginBackground.png"
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />

        <Box
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: "60px 56px",
          }}
        >
          <p style={{ fontSize: 36, fontWeight: 700, color: "#ffffff", marginBottom: 20, marginTop: 0 }}>
            Start Your Global Trade Journey
          </p>

          <p style={{ fontSize: 16, color: "rgba(255,255,255,0.8)", marginBottom: 48, marginTop: 0 }}>
            Register your verified business profile and connect with trusted international partners across the globe.
          </p>

          <Flex direction="column" gap={20}>
            {[
              { icon: <IconBuilding size={18} />, text: "Register your company with verified credentials" },
              { icon: <IconWorld size={18} />, text: "Access a network spanning 20+ countries" },
              { icon: <IconId size={18} />, text: "Secure document verification process" },
            ].map(({ icon, text }) => (
              <Flex key={text} align="center" gap={14}>
                <Box
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 8,
                    background: "#ffffff1a",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#ffffff",
                    flexShrink: 0,
                  }}
                >
                  {icon}
                </Box>
                <span style={{ fontSize: 14, color: "rgba(255,255,255,0.8)" }}>{text}</span>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Box>

      <Box
        px={{ base: "md", sm: "xl" }}
        py={{ base: "lg", sm: "48px" }}
        style={{ flex: 1, background: "var(--mantine-color-white)", overflowY: "auto" }}
      >
        <Flex direction="column" align="center" mb="xl">
          <img src="/gtLogo.svg" alt="GTsetu" style={{ height: 64, width: "auto" }} />
        </Flex>

        {children}

        <Flex justify="center" mt="md">
          <Anchor component={Link} to="/login" size="sm" c="slate.6">
            ← Back to Login
          </Anchor>
        </Flex>
      </Box>
    </Box>
  );
}
